
<template>
  <div>
    <div style="margin-top:75px; padding:10px;min-height:calc(100vh-75px);">
      <h2 class="title">
        UPS Ship
      </h2>
      <label>Enter Order Number</label>
      <input
        v-model="ordernumber"
        class="custom_form text-center"
      >   
      <button
        type="button"
        @click="getOrderNumber"
      >
        Search
      </button>        
    </div>        

    <div
      v-if="content"
      style="padding:10px;min-height:calc(100vh-75px);"
    >
      <div style="display: grid; grid-template-columns: 50% 50%; background-color:#eeeeaa;">
        <div>
          <h4>Ship To</h4>
          {{ this.ShipTo.ATTENTION }}<br>
          {{ this.ShipTo.ADDRESS1 }}, {{ this.ShipTo.ADDRESS2 }}<br>
          {{ this.ShipTo.CITY }},
          {{ this.ShipTo.POSTALCODE }}, {{ this.ShipTo.PROVINCE }}, {{ this.ShipTo.COUNTRY }}<br>                
        </div>
        <div v-if="activeTrackingNumbers.length > 0">
          <h4>Active Tracking Numbers</h4>   
          {{ this.ShipTo.SHIPID }}
          <li
            v-for="(item, index) in activeTrackingNumbers"
            style="list-style:none; cursor:none"
          >                       
            <!--<input :id="item.UCC128" :value="item" name="item" type="checkbox" v-model="checkedTRACKINGNUM" />-->
            <label :for="item.UCC128">
              <b @click="previewLabel(item.CART_CARR_LABEL_DATA)">{{ item.TRACKINGNUM }}</b> : [ITEM: {{ item.ITEM }}] [{{ item.ORD_SHIP_QTY }} {{ item.SKU_CODE }}] [{{ item.ORD_TOT_WGT }} {{ item.WGT_MEAS_CODE }}] [SSCC18: {{ item.UCC128 }}] [PO: {{ item.ORD_PO_NUM }}]
            </label>            
          </li>   
          <!--<button  type="button" v-on:click="VoidSelectedShipments"  v-if="checkedTRACKINGNUM.length > 0">Void UPS Shipment</button>-->
          <button
            type="button"
            @click="VoidSelectedShipments"
          >
            Void UPS Shipment
          </button>
        </div>                      
      </div>

      <div
        v-if="content.length > 0"
        style="display: grid; grid-template-columns: 50% 50%"
      >
        <div>
          <h4>Items To Ship</h4>
          <li
            v-for="(item, index) in content"
            style="list-style:none; cursor:none"
          >                       
            <input
              :id="item.UCC128"
              v-model="checkedSSCC"
              :value="item"
              name="item"
              type="checkbox"
            >
            <label :for="item.UCC128">
              [ITEM: {{ item.ITEM }}] [{{ item.ORD_SHIP_QTY }} {{ item.SKU_CODE }}] [{{ item.ORD_TOT_WGT }} {{ item.WGT_MEAS_CODE }}] [SSCC18: {{ item.UCC128 }}]  [PO: {{ item.ORD_PO_NUM }}]
            </label>            
          </li>        
        </div>
        <div>
          <h4>Selected Items To Ship</h4>
          <li
            v-for="(item, index) in checkedSSCC"
            style="list-style:none; cursor:none"
          > 
            [ITEM: {{ item.ITEM }}] [{{ item.ORD_SHIP_QTY }} {{ item.SKU_CODE }}] [{{ item.ORD_TOT_WGT }} {{ item.WGT_MEAS_CODE }}] [SSCC18: {{ item.UCC128 }}] [PO: {{ item.ORD_PO_NUM }}]
          </li>
          <button
            v-if="checkedSSCC.length > 0"
            type="button"
            style="width:100px;"
            @click="shipSelectedItems"
          >
            Process UPS Shipment
          </button>
        </div>               
      </div>
        


      <!--
        <div >
            <button type="button" v-on:click="printDoc">Print UPS Labels</button>  
            <div id='imgCont' v-for="(img,index,array) in Labels" >                                
                original : {{UPSResponse.ShipmentResponse.ShipmentResults.PackageResults[index].ShippingLabel.GraphicImage }}
                <img :src='"data:image/png;base64," + UPSResponse.ShipmentResponse.ShipmentResults.PackageResults[index].ShippingLabel.GraphicImage' />                                
                {{img.ShippingLabel.GraphicImage}} <br><br><br>
                <img :src='"data:image/png;base64," + img' />           
                <img :src='img' />
                <hr>
            </div>                        
        </div>
        -->


      <!-- popup -->
      <div
        v-if="showPopup"
        class="popup"
      >              
        <div class="pCenter">                
          <button
            type="button"
            @click="printDoc"
          >
            Print UPS Labels
          </button> 
          <div class="pContent">                
            <div
              v-for="(img,index,array) in Labels"
              id="imgCont"
            >             
              <img :src="img">
              <hr>
            </div>                                                                                                                    
          </div>                   
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import axios from 'axios'

var doc = new jsPDF({ compress: true })
/*
const doc = new jsPDF({
    compress: true,
    orientation: 'portrait', 
    unit: 'in', 
    fromat: [4,6]
});     
*/

export default {
  name: 'Bookingstatus',
    
  data() {
    return { 
    ordernumber: null,
    content: null,
    activeTrackingNumbers: [],
    checkedSSCC:[],
    checkedTRACKINGNUM: [],
    UPSResponse: null,
    Labels: [],
    ShipTo: {},
    showPopup: false
   }
  },
  watch: {      
  },

  created() {        
    
  },  
  updated(){

  },
  mounted (){
  
  },
  methods: {
    closePopup() {
        this.showPopup = false
    },
    getOrderNumber() {         
        
        this.activeTrackingNumbers = []
        this.checkedSSCC = []
        this.checkedTRACKINGNUM = []
        this.Labels = []        

        var vm = this
        axios.get('https://api.transplus.com/getwmsorders/' + this.ordernumber)
        .then((response) => {           
           
           this.ShipTo.ATTENTION = response.data[0][0].ATTENTION
           this.ShipTo.ADDRESS1 = response.data[0][0].ADDRESS1
           this.ShipTo.ADDRESS2 = response.data[0][0].ADDRESS2
           this.ShipTo.CITY = response.data[0][0].CITY
           this.ShipTo.POSTALCODE = response.data[0][0].POSTALCODE
           this.ShipTo.PROVINCE = response.data[0][0].PROVINCE
           this.ShipTo.COUNTRY = response.data[0][0].COUNTRY
           this.ShipTo.SHIPID = response.data[0][0].SHIPID
           this.ShipTo.ORD_PO_NUM = response.data[0][0].ORD_PO_NUM
           this.ShipTo.CART_CARR_LABEL_DATA = response.data[0][0].CART_CARR_LABEL_DATA

            //console.log(response.data[0][0].CART_CARR_LABEL_DATA)

            //---filter trackingnumbers
            vm.activeTrackingNumbers = response.data[0].filter((item) =>{
                //alert(JSON.stringify(item.TRACKINGNUM))
                return item.TRACKINGNUM
            })
            //alert(JSON.stringify(this.activeTrackingNumbers))  

            vm.content = response.data[0].filter((item) =>{
                //alert(JSON.stringify(item.TRACKINGNUM))
                return !item.TRACKINGNUM
            })                                    

            //vm.content = response.data[0]
        })
        .catch(e => {
          //alert(e)
          console.log(e)
        })          
    },
    printDoc(){
        
        //update the database with the tracking numbers

        /* alread done on the backend when calling for ship
        var vm = this
        axios.post('https://api.transplus.com/updatewmsTrackingNumber/', { upsData: this.UPSResponse.ShipmentResponse.ShipmentResults.PackageResults, ssccData: this.checkedSSCC } )
        .then((response) => {                       
            alert('WMS UPDATED')
        })
        .catch(e => {
          alert(e)
          console.log(e)
        })         
        */
        
        /*
        doc.autoPrint({variant: 'non-conform'});        
        doc.output('dataurlnewwindow');//This is a key for printing
        */
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));


        this.showPopup = false
        this.getOrderNumber()
    },
    previewLabel(label){            
        if (label) {
            //rotate label 90degrees
            this.rotateBase64Image90deg(label,90)                            
            //remove first page which is always blank
            doc.deletePage(1)    

            setTimeout(function(){
                var blob = doc.output("blob");
                window.open(URL.createObjectURL(blob));
            },2000);
        }else{
            alert('NoPreiew, goto UPS.com to acquire label')
        }

    },
    rotateBase64Image90deg(base64data, callback) {
        const canvas = document.createElement('canvas');
        var ctx = canvas.getContext("2d");

        var image = new Image();                 
        let vm = this
        image.onload = function() {
            //alert("ONLOAD")
            canvas.width = image.height;
            canvas.height = image.width;            
            
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(90 * Math.PI / 180);            
            ctx.drawImage(image, image.width / -2, image.height / -2);      
            
            console.log(canvas.toDataURL("image/png", 100))
            vm.Labels.push (canvas.toDataURL("image/png", 100))

            doc.addPage();
            doc.addImage(canvas.toDataURL("image/png", 100), "PNG", 0, 0, 210,  320)              
        }        
        //***** image.onload will not fire (execute) IF image.src comes before, so image.src needs to come after the onload
        image.src = "data:image/png;base64," + base64data;     
  

        /*
        setTimeout(function(){  
            var img = document.querySelectorAll("div#imgCont img");                
            var counter=0;            
            img.forEach(img => {        
                //if (counter > 0) doc.addPage();                
                //doc.addPage();
                doc.addImage(img.getAttribute("src"), "PNG", 0, 0, 210,  320)                         
                counter++;
            });
        },500) 
        */

    },    
    VoidSelectedShipments(){
        var vm = this

        var trackingnumbers = [] 
        axios.post('https://api.transplus.com/upscancel/', { shipid : this.ShipTo.SHIPID, trackingnumber : trackingnumbers } )
        .then((response) => {               
            vm.getOrderNumber()
        })
        .catch(e => {
          alert(e)
          console.log(e)
        }) 


        /* --- select individual tracking numbers to cancel 
        var trackingnumbers = [] 
        this.checkedTRACKINGNUM.forEach((item)=> {
            trackingnumbers.push(item.TRACKINGNUM)            
        })                
        axios.post('https://api.transplus.com/upscancel/', { trackingnumber : trackingnumbers } )
        .then((response) => {               
            vm.getOrderNumber()
        })
        .catch(e => {
          alert(e)
          console.log(e)
        })  
        ------------------------------------------*/

        this.checkedTRACKINGNUM=[]

    },
    shipSelectedItems() { 
        doc = new jsPDF({ compress: true })

        var vm = this
        axios.post('https://api.transplus.com/shipwmsorders/', { data: this.checkedSSCC} )
        .then((response) => {           
            
            this.UPSResponse = response.data

            console.log(this.UPSResponse)
            
            if (typeof this.UPSResponse === 'string' || this.UPSResponse instanceof String){
                alert(this.UPSResponse)
                return
            }
            //check if object is an array, if not turn it to an array
            else if (!Array.isArray(this.UPSResponse.ShipmentResponse.ShipmentResults.PackageResults)) {                 
                var x = this.UPSResponse.ShipmentResponse.ShipmentResults.PackageResults                
                this.UPSResponse.ShipmentResponse.ShipmentResults.PackageResults = []                     
                this.UPSResponse.ShipmentResponse.ShipmentResults.PackageResults.push(
                    x
                )
                
            }else {
                this.UPSResponse = response.data
            }

            //rotate label 90degrees
            this.UPSResponse.ShipmentResponse.ShipmentResults.PackageResults.forEach((item,index,array) => {
                this.rotateBase64Image90deg(item.ShippingLabel.GraphicImage,90)                
            });
            //remove first page which is always blank
            doc.deletePage(1)    
            //this.showPopup = true
            //remove selected
            this.checkedSSCC=[]


            setTimeout(function(){
                var blob = doc.output("blob");
                window.open(URL.createObjectURL(blob));
            },2000);

            this.getOrderNumber()


        })
        .catch(e => {
          //alert(e)
          console.log(e)
        })          
    }    
  }
}
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
    margin: 10px;
}
b:hover {
    background-color:white;
    cursor:pointer;
}

.popup{
  position: fixed;
  z-index: 99999;
  top:0;
  left:0;
  width:100%;
  height:100%;  
  background-color: rgba(0,0,0,0.5);  
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;  
}
.pCenter{       
    margin: 0px;
    background-color: rgba(0,0,0,0.5);    
    position: absolute;
    border-radius:10px;
    padding:10px;    
}
.pContent{
  /*max-height: 400px;*/
  position:relative;
  height:100%;
  overflow: auto;    
}   
.pClose {
  cursor: pointer;
  padding-top:5px;
  padding-right:5px;  
  transition: all 100ms;
  font-size:1.2em;
  font-weight: bold;
  text-decoration: none;
  color: #ff0000;
  filter: brightness(1000%);
  &:hover {
    filter: brightness(100%);
  }
}

</style>